import type { AppModule } from '@shared/presentation/router/composition.js';

/**
 * `app-shell` module: the shell's host route.
 *
 * `meta.layoutHost` is the marker `composeRoutes` looks for to hang the other
 * features' routes off this one. It is the only route that declares it.
 */
export const appShellModule: AppModule = {
  name: 'app-shell',
  routes: [
    {
      path: '/',
      component: () => import('./presentation/AppShell.vue'),
      meta: { layoutHost: true },
      children: [],
    },
  ],
};
